import React from 'react';
import './AboutHero.css';

const AboutHero: React.FC = () => {
  return (
    <section className="about-hero-section">
      <div className="container">
        <div className="about-hero-content">
          <div className="about-hero-text">
            <h1>About Kavodax</h1>
            <p>
              We're revolutionizing cross-border payments by making them faster, 
              more affordable, and accessible to everyone. Our mission is to break 
              down financial barriers and connect people globally through innovative 
              blockchain technology.
            </p>
            <div className="about-hero-stats">
              <div className="stat-item">
                <span className="stat-value">150+</span>
                <span className="stat-label">Countries Supported</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">$10M+</span>
                <span className="stat-label">Transactions Processed</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">99.9%</span>
                <span className="stat-label">Uptime</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
